import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { connect } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import ErrorConfirmation from '@/components/ErrorConfirmation'
import Page from '@/components/Page'
import { resetRequest } from '@/store/actions'
import { isRequestError, isRequestPending } from '@/store/selectors'

import { fetchGroups } from './actions'
import { FETCH_GROUPS } from './actionTypes'
import GroupList from './GroupList'
import messages from './messages'
import { getGroups } from './selectors'

const defaultSort = {
  displayName: {
    direction: 'asc',
    position: 2
  }
}

function OrganizationGroupsPage(props: any) {
  const intl = useIntl()

  const history = useHistory()
  const location = useLocation()

  // componentDidMount
  useEffect(() => {
    props.actions.resetRequest([FETCH_GROUPS])
    props.actions.fetchGroups()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const navigateToViewGroup = (groupId: any) => {
    history.push(`${location.pathname}/${groupId}/members`)
  }

  const goBack = () => {
    history.push(location.pathname.slice(0, Math.max(0, location.pathname.lastIndexOf('/'))) + '/users')
  }

  return (
    <Page isLoading={props.isLoading} loadingMessage={<FormattedMessage {...messages.loading} />}>
      <Page.Header
        title={<FormattedMessage {...messages.title} />}
        goBack={goBack}
        backNavTitle={<FormattedMessage {...messages.back} />}
      />

      {props.hasError ? (
        <ErrorConfirmation
          error={intl.formatMessage(messages.errorTitle)}
          subMessage={intl.formatMessage(messages.errorMessage)}
        />
      ) : (
        <GroupList groups={props.groups} onView={navigateToViewGroup} sortingColumn={defaultSort} />
      )}
    </Page>
  )
}

OrganizationGroupsPage.displayName = 'OrganizationGroupsPage'

OrganizationGroupsPage.propTypes = {
  actions: PropTypes.shape({
    fetchGroups: PropTypes.func.isRequired,
    resetRequest: PropTypes.func.isRequired
  }).isRequired,
  groups: PropTypes.arrayOf(PropTypes.object),
  hasError: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired
}

OrganizationGroupsPage.defaultProps = {
  groups: [],
  hasError: false
}

const DisconnectedOrganizationGroupsPage = OrganizationGroupsPage
export { /** @deprecated */ DisconnectedOrganizationGroupsPage as OrganizationGroupsPage }

const mapStateToProps = (state: any) => ({
  groups: getGroups(state),
  hasError: isRequestError(state, [FETCH_GROUPS]),
  isLoading: isRequestPending(state, [FETCH_GROUPS])
})

const mapDispatchToProps = (dispatch: any) => ({
  actions: bindActionCreators({ fetchGroups, resetRequest }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(DisconnectedOrganizationGroupsPage)
